import { render, staticRenderFns } from "./ArrematanteInput.vue?vue&type=template&id=8fb2e5c8&scoped=true"
import script from "./ArrematanteInput.vue?vue&type=script&lang=js"
export * from "./ArrematanteInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fb2e5c8",
  null
  
)

export default component.exports